import { Component, OnInit, AfterViewChecked, ElementRef, ViewChild } from '@angular/core';
import { AdvtService } from '../../../_services/advt.service';
import { AlertService } from '../../../_services/alert.service';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase';
import { ChatService } from '../../../_services/chat.service';
import 'rxjs/add/operator/map';
import * as moment from 'moment';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';

interface Post {
  touser: Number;
  fromuser: Number;
  is_seen: Number;
  message: string;
}

@Component({
  selector: 'app-free-chat',
  templateUrl: './free-chat.component.html',
  styleUrls: ['./free-chat.component.css']
})
export class FreeChatComponent implements OnInit {

  @ViewChild('scrollMe') private myScrollContainer: ElementRef;

  type = "free";
  pageSize: Number = 10;
  fromuser: Number = 1;
  message: string = '';
  touser: Number = 1;
  loading = false;
  loggedUser;
  mainLoader = '../../assets/images/BigLoader.gif';
  selectedUser = null;
  members: Array<any> = [];
  is_seen: Number = 0;
  currentDate: {};
  pair_id: any;
  postsCol: AngularFirestoreCollection<Post>;
  posts: Observable<Post[]>;
  setDate = moment;
  time =null;
  sub: Subscription;
  _id;
  count;
  type2 = "freechat";

  constructor(private afs: AngularFirestore,
              private alertService: AlertService,
              private _chatService: ChatService,
              private advtService: AdvtService,
              private route : ActivatedRoute)
  {

  }

  ngOnInit() {

    // this.sub = this.route.params.subscribe((params) => {
    //   this._id = params['id'];
    // });
    //  this.time = firebase.firestore.Timestamp;

    //  .firestore.FieldValue.serverTimestamp()
    this.scrollToBottom();
    if (localStorage.getItem('currentUser')) {
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
      this.loggedUser = userInfo.result;
    }
    this.getMembers();
    this.currentDate = new Date();
    // const timestamp = this.afs.serverTimestamp()
  }
  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }

  public getMembers() {
    this.loading = true;
    let params = {limit:10,
      offset:0,
      user_id:this.loggedUser.id
    }
    this._chatService.getMembersFree(params)
      .subscribe(data => {
        this.members = data.result;
        this.count = data.count;
        if(!data.count){
          this.posts = null;
          this.selectedUser = null;
        }
        this.loading = false;

      }, error => {

      });
  }


  getMessages = async (user) => {

    this.loading = true;
    const { userId, itemid } = user;
    const ids = [
      userId,
      this.loggedUser.id
    ];
    this.selectedUser = user;
    const minNum = Math.min(...ids);
    const maxNum = Math.max(...ids);
    this.postsCol = this.afs
      .collection('TestChat', ref => ref
        .where('pair_id', '==', `${minNum}|${maxNum}|${itemid}`).orderBy('created_at', 'asc'));
    this.posts = await this.postsCol.valueChanges();
    setTimeout(() => {
      this.loading = false;
    }, 500);

  }

  addPost() {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp();
    const { userId, itemid } = this.selectedUser;
    const ids = [
      userId,
      this.loggedUser.id
    ];
    const minNum = Math.min(...ids);
    const maxNum = Math.max(...ids);
    // setTimeout(() => {
    //const timestamp = moment().format('x'); // returns the Unix Millisecond Timestamp;
    if (this.message !== '') {
      this.afs.collection('TestChat').add({
        'fromuser': this.loggedUser.id,
        'pair_id': `${minNum}|${maxNum}|${itemid}`,
        'is_seen': this.is_seen,
        'message': this.message,
        'updated_at': timestamp,
        'created_at': timestamp
      });
      this.message = '';
    }
    // }, 1000);

  }


  createPairId() {
    let pairId;
    pairId = `${this.fromuser}|${this.touser}`;
    this.pair_id = pairId;
  }

  /**
   * function to Disable Space
   * @param event
   */
  _checkSPace(event: any) {
    //this.durCheck = regexp.test(event.target.value)
    if (event.which === 32 && event.target.selectionStart === 0) {
      return false;
    }

    if (event.which == 13) {

      if (this.message !== '') {
        let status = {
          'item_id':this.selectedUser.itemid,
          'to':this.selectedUser.userId,
          'message':this.message,
          'sender_id':this.loggedUser.id
        };

        this.addPost();
        this.advtService.sendchatmessage(status).subscribe(data => {
          if (data.status === 200) {
            this.alertService.success(this.selectedUser.username + "You have received new chat message.");
          } else {
            //this.bidPost = false;
          }
        }, error => {
        });
      }
    }

  }


  keyDownFunction(event) {
    if (event.keyCode == 13) {

      this.addPost();

      // rest of your code
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/authorized-data/free/free-chat/free-chat.component.ts